import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {StorageServiceProvider} from '../../../core/services/storage-service/storage-service';
import {ConfigServiceProvider} from '../../../core/services/config-service/config-service';

@Injectable()
export class QuizzesServiceProvider {

  constructor(private http: HttpClient, private storageService: StorageServiceProvider, private configService: ConfigServiceProvider) {
  }

  private setQuiz(quiz) {
    return this.storageService.getObject('quizzes').then((allQuizzes: Array<any>) => {
      let exists = false;
      for(let i = 0; i < (allQuizzes || []).length; i++) {
        allQuizzes[i] = quiz;
        exists = true;
      }

      if(!exists) {
        allQuizzes.push(quiz);
      }

      return this.storageService.setObject('quizzes', allQuizzes);
    })
  }

  private loadQuizzes() {
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('quizzes'))
        .toPromise().then((response: any) => {
          this.storageService.setObject('quizzes', response)
          .then(() => resolve()).catch((err) => reject(err));
        });
    });
  }

  private loadQuiz(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('quizDetails') + id).toPromise()
        .then((quiz: any) => this.setQuiz(quiz)).catch(err => reject(err))
        .then(() => resolve());
    });
  }

  load() {
    return this.loadQuizzes();
  }

  loadOne(id) {
    return this.loadQuiz(id);
  }

  getQuizzes() {
    return this.storageService.getObject('quizzes');
  }

  getQuiz(id) {
    return this.storageService.getObject('quizzes')
      .then((allQuizzes: Array<any>) => {
        for(let i = 0; i < (allQuizzes || []).length; i++) {
          if(allQuizzes[i].quizId === id) {
            return allQuizzes[i];
          }
        }
      })
  }

  solve(solution) {
    return this.http.post(this.configService.getUrl('quizzes'), solution).toPromise();
  }

  startQuiz(quizId) {
    return this.http.get(this.configService.getUrl('quizStart') + quizId).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/modules/quizzes/services/quizzes-service/quizzes-service.ts